/* eslint-disable import/prefer-default-export */
import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function duplicateStitchedMCQ(id) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}admin/questions/${id}/duplicate`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
